import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SaveCustomerOrderGeneral(formData) {
  const response = await $.soap({
    body: {
      SaveCustomerOrderGeneral: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        GeneralFormData: formData.generalFormData,
        OrderId: formData.orderId,
        OrderTypeId: formData.orderTypeId
      }
    },
    blueprint: {
      savedId: '$..ID'
    }
  });

  cleanUpResponse(response);
  return response.savedId;
}
